module.exports = __webpack_public_path__ + "static/media/uk.b302ad07.svg";